import { CLIENT } from "../types";

export const setSelectedClient = (selectClient: any) => {
	return {
		type: CLIENT.CLIENT_SET_SELECTED,
		payload: { ...selectClient },
	};
};

export const clearSelectedClient = () => {
	return {
		type: CLIENT.CLIENT_CLEAR_SELECTED,
	};
};
export const setSelectedClientName = (selectClient: any) => {
	return {
	  type: CLIENT.CLIENT_NAME_SET_SELECTED,
	  payload: {...selectClient}
	}
  }
  
  export const clearSelectedClientName = () => {
	return {
	  type: CLIENT.CLIENT_NAME_CLEAR_SELECTED
	}
  }
  